<template>
    <div class="bax-modal-wrap" v-if="open === true">
        <div class="container">
            <div class="bax-modal-content-wrap">
                <div class="bax-modal-content">
                    <div class="bax-icon bax-remove d-flex align-items-end justify-content-end">
                        <i class="icon-close" @click.prevent="cancelModal"></i>
                    </div>
                    <div class="modal-content">
                        <h2>{{ data.drug_name }}</h2>
                        <p class="recap">{{ data.containers.length }} compatible container{{ data.containers.length > 1 ? 's' : '' }}</p>
                        <template v-for="(item, ItemIndex) in data.containers">
                            <div class="container-element" :key="'container_' + ItemIndex">
                                <div class="item-header">
                                    <h2>{{ item.name }}</h2>
                                    <h3 v-if="item.name_description">{{ item.name_description }}</h3>
                                </div>
                                <table>
                                    <template v-for="(detail, detailIndex) in item.details">
                                        <tr :key="'container_' + detailIndex">
                                            <td class="type">{{ detail.label }}</td>
                                            <td class="description">{{ detail.value }}</td>
                                        </tr>
                                    </template>
                                </table>
                            </div>
                        </template>
                        <p class="notes">This stability guide is subject to updates.  For the most current stability, please call your local compounding site.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'ViewStabilityModal',
    components: {
    },
    props: {
        open: {
            required: true,
        },
        data: {
            required: true,
        },
    },
    data() {
        return {
        };
    },
    methods: {
        cancelModal() {
            this.$emit('modal_view_stability_close');
        },
    },
};
</script>
